const SvgIconHamburger = (props) => (
  <svg viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 12h18v-2H0v2Zm0-5h18V5H0v2Zm0-7v2h18V0H0Z" />
  </svg>
);

export default SvgIconHamburger;
